'use client';

import { usePathname } from 'next/navigation';
const DEFAULT_TABLE_ACTION = 'summary';
const regex = /^\/dataset\/(?<datasetName>[^/]+)\/(?<tableName>[^/]+)\/(?<tableAction>[^/]+)$/;
export const useRouteParams = () => {
  const pathname = usePathname();
  const match = pathname.match(regex);
  const tableAction = match?.groups?.tableAction ?? DEFAULT_TABLE_ACTION;
  const tableName = match?.groups?.tableName;
  const datasetName = match?.groups?.datasetName;
  return {
    tableAction,
    tableName,
    datasetName
  };
};